import en from './payments.en';

const enConfig = { en };

export default enConfig;
